// extracted by mini-css-extract-plugin
export default {"table":"Support_table__hCXb7","action":"Support_action__cWR32","menuItemActive":"Support_menuItemActive__hR0H4"};